export const itemHeight = 63;



/** WEBPACK FOOTER **
 ** ./shared-components/SearchBar/constants.js
 **/